import { NgModule } from '@angular/core';
import { RouterModule, Routes, } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { LoginFailedComponent } from './pages/login-failed/login-failed.component';
import { HomeComponent } from './pages/home/home.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';

const routes: Routes = [
  // `/` and `/home` are the dashboard; My Alerts stays at `/notifications`.
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'clients',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule),
  },
  {
    path: 'members',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/members/members.module').then(m => m.MembersModule),
  },
  {
    path: 'logs',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/logs/logs.module').then(m => m.LogsModule),
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent
  },
  {
    path: 'access-denied',
    component: CustomLayoutComponent,
    children: [
      {
        path: '',
        component: AccessDeniedComponent
      }
    ]
  },
  {
    path: 'cases',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/cases/cases.module').then(m => m.CasesModule),
  },
  {
    path: 'home',
    component: CustomLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      }
    ]
  },
  {
    path: 'search',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'finance',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/finance/finance.routes')
  },
  {
    path: 'marketing',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/marketing/marketing.routes')
  },
  {
    path: 'products',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/products/products.routes')
  },
  {
    path: 'law-firm',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/law-firms/law-firms.routes')
  },
  {
    path: 'law-firm-group',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/law-firm-groups/law-firm-groups.routes')
  },
  {
    path: 'legal-network',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/legal-network/legal-network.routes')
  },
  {
    path: 'portal',
    component: CustomLayoutComponent,
    children: [
      {
        path: 'users',
        loadChildren: () => import('./pages/portal/users/portal-users.module').then(m => m.PortalUsersModule)
      },
      {
        path: 'permissions',
        loadChildren: () => import('./pages/portal/permissions/portal-permissions.module')
          .then(m => m.PortalPermissionsModule)
      },
      {
        path: 'feature-flags',
        loadChildren: () => import('./pages/portal/feature-flags/portal-feature-flags.module')
          .then(m => m.PortalFeatureFlagsModule)
      }
    ]
  },
  {
    path: 'staff',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/staff/staff.routes')
  },
  {
    path: 'notifications',
    component: CustomLayoutComponent,
    loadChildren: () => import('./pages/notifications/notifications.routes')
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}